<template>
    <div>
        <div id="minimal-logo"><img src="/logo.png" v-if="layoutData.hasLogo"/></div>

        <div id="minimal-content-wrapper">
            <router-view/>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';
    import {State} from 'vuex-facing-decorator';

    @Component({
        name: 'LayoutMinimal',
    })
    export default class LayoutMinimal extends Vue
    {
        @State('layoutData') layoutData: LayoutData;

        mounted(): void
        {
            document.documentElement.classList.add('minimal');
        }

        unmounted(): void
        {
            document.documentElement.classList.remove('minimal');
        }
    };
</script>

<style lang="scss" src="../stylesheet/layout_minimal.scss"/>